@if (viewMode === 'chips') {
  <div class="d-flex gap-1" style="margin-top: var(--space-x-3px)">
    @for (filter of appliedFilters; track $index) {
      <div
        class="badge filter-badge text-black d-flex align-items-center filterBadge"
        style="background-color: var(--color-bg-soft); font-size: var(--fs-lg)"
        [ngbPopover]="addFilterPopover"
        placement="bottom-left"
        #filterPopover="ngbPopover"
        (click)="openPopover(filter)"
        [autoClose]="false"
        popoverClass="filterPopover"
      >
        <span class="me-1" data-cy="pharmacyFilter" data-testid="pharmacyFilter">{{ filter.display }}</span>

        @if (filter.icon) {
          <chitin-icon class="me-1" style="font-size: var(--fs-xs)" [icon]="filter.icon" />
        }
        @if (filter.iconText && !filter.iconTextPostfix) {
          <span class="me-1 iconTextSmall">{{ filter.iconText }}</span>
        }

        <span>{{ filter.displayValue ?? filter.value }}</span>

        @if (filter.iconText && filter.iconTextPostfix) {
          <span>{{ filter.iconText }}</span>
        }

        <a class="ms-1" data-cy="removeFilter" (click)="removeFilter($index)">
          <chitin-icon icon="fa-solid fa-xmark" />
        </a>
        <ng-template #addFilterPopover>
          <div class="filterPopoverContainer">
            @if (activeFilter) {
              <app-data-view-add-filter [model]="activeFilter" [activePopover]="filterPopover" (filterChanged)="filterEdited($event)" />
            }
          </div>
        </ng-template>
      </div>
    }
  </div>
} @else {
  <div>Not supported</div>
}
